import { useEffect, useState } from "react";
import { Reveal } from "@/components/invite/Reveal";

const pad = (n) => String(n).padStart(2, "0");

export default function Countdown({ dateIso }) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, new Date(dateIso).getTime() - now);
  const units = [
    ["Días", Math.floor(diff / 86400000)],
    ["Horas", Math.floor(diff / 3600000) % 24],
    ["Minutos", Math.floor(diff / 60000) % 60],
    ["Segundos", Math.floor(diff / 1000) % 60],
  ];

  return (
    <div className="grid grid-cols-4 gap-2 sm:gap-6" data-testid="countdown-timer">
      {units.map(([label, value], i) => (
        <div key={label} className="text-center">
          <Reveal delay={0.08 * i}>
            <span className="font-serif text-5xl sm:text-7xl font-light text-ink tabular-nums">
              {pad(value)}
            </span>
          </Reveal>
          <p className="overline-label text-bronze mt-3" data-testid={`countdown-label-${label.toLowerCase()}`}>
            {label}
          </p>
        </div>
      ))}
    </div>
  );
}
